import {
    post,
    get,
    put,
    del
} from "./http"
const template = {
    // 获得列表
    getList(type, params) {
        return get("client/message-template/type/" + type, params)
    },
    //添加模板
    addTemplate(params) {
        return post("client/message-template", params)
    },
    //编辑模板
    editTemplate(params) {
        return put("client/message-template", params)
    },
    // 获取模板详情
    getDetail(id) {
        return get("client/message-template/" + id)
    },
    // 修改模板
    editDetail(params) {
        return put("client/message-template", params)
    },
    renewal(params){
        return put('client/message-template/renewal/'+params.id)
    },
    // 删除模版
    delTemplate(id) {
        return del("client/message-template/" + id)
    },
    // 发送消息时 模板列表
    sendtemplate(type, params) {
        return get("client/message-template/detail/type/" + type, params)
    },
    //管控回落短信模板列表
    sendLimitTemplate(type, params) {
        return get("client/message-template/detail/limit/type/" + type, params)
    },

    // 5G视信发送消息时 模板列表
    sendtemplate5GShiXin(type, params) {
        return get("client/message-template/detail/type/5GShiXin/" + type, params)
    },
    // 获取阅信模版列表
    getYueXinList(params) {
        return get("client/yuexin-template", params)
    },
    // 删除阅信模版
    delYueXinTemplate(id) {
        return del("client/yuexin-template/" + id)
    },
    // 获取阅信详情
    getYueXinDetail(id) {
        return get("client/yuexin-template/" + id)
    },
    // 添加阅信模版
    addYueXinTemplate(params) {
        return post("client/yuexin-template", params)
    },
    editYueXinTemplat(params){
        return put("client/yuexin-template", params)
    },
    // 上传阅信文件
    uploadYueXin(params) {
        return post("client/material/yuexin", params)
    },
    // 查询模板是否含有动态变量
    getTplParams(id){
        return get("client/yuexin-template/getTplParams/" + id)
    },

    //查询5G阅信模板下拉列表
    get5GTemplateList(){
        return get("client/yuexin-reprot/query5GTemplate")
    },
    //生成5G消息模板彩信
    addMms(id){
        return get('client/message-template/createMms/'+id)
    },
    //删除彩信
    delMms(id){
        return del('client/message-template/delMms/'+id)
    },
    //复制5G消息模板
    copyMessageTemp(id){
        return put('client/message-template/copyMessageTmp/'+id)
    },
    //复制5Gshixin消息模板
    copyMMSTemp(id){
        return put('client/message-template/copyMMS/'+id)
    },
    //5G视信模板对应媒体文件续期
    chanegExpired(params){
        return get('/client/message-template/changeTemplateExpired',params)
    }

}
export default template;
